function isValidUrl(str): boolean {
    let url;

    try {
        url = new URL(str);
    } catch (_) {
        return false;
    }

    if (str.indexOf('https://') > -1) {
        if (str.substr(8, str.length).indexOf('//') > -1) {
            return false;
        }
    }

    if (str.indexOf('http://') > -1) {
        if (str.substr(7, str.length).indexOf('//') > -1) {
            return false;
        }
    }

    return url.protocol === "http:" || url.protocol === "https:";
}

export default isValidUrl;
